import React, { useState } from 'react';
import { Text, Icon } from '../../../common/components';
import BuildingLog, { BuildingLogItem } from './BuildingLog';

import { Colors } from '../../../common/constants/Colors';
type TextWeights = '400' | '500' | '600' | '700';

export interface LogsGroupProps {
  title: string;
  subtitle: string | React.ReactNode;
  subtitleWeight?: TextWeights;
  subtitleColor?: Colors;

  logs: BuildingLogItem[];

  isExpanded?: boolean;
  onToggle?: () => void;

  headerClassName?: string;
}

export const LogsGroup: React.FC<LogsGroupProps> = ({
  title,
  subtitle,
  subtitleWeight = '700',
  subtitleColor = 'Neutral800',
  logs,
  isExpanded: externalIsExpanded,
  onToggle,
  headerClassName = "BuildingLogsGroup__header"
}) => {
  const [internalIsExpanded, setInternalIsExpanded] = useState(false);

  const isExpanded = externalIsExpanded !== undefined ? externalIsExpanded : internalIsExpanded;

  const toggleExpand = () => {
    if (onToggle) {
      onToggle();
    } else {
      setInternalIsExpanded(prev => !prev);
    }
  };

  return (
    <div className="BuildingLogsGroup mt-1 mb-1">
      <div
        className={headerClassName}
        onClick={toggleExpand}
      >
        <Text className='mr-2' size="body-large" color="Neutral700">
          {title}
        </Text>

        <div style={{ flexGrow: 1 }}>
          {typeof subtitle === 'string' ? (
            <Text size='body-medium' weight={subtitleWeight} color={subtitleColor}>
              {subtitle}
            </Text>
          ) : subtitle}
        </div>

        <Icon className='BuildingLogsGroup__toggle-icon'
          name={isExpanded ? "arrowDown" : "arrowRight"}
          color="Primary500"
        />
      </div>

      {isExpanded && (
        <div className="BuildingLogsGroup__logs mt-1 mb-1">
          {logs.map((log) => (
            <BuildingLog key={log.id} log={log} />
          ))}
        </div>
      )}
    </div>
  );
};

export default LogsGroup;
